import {Component} from '@angular/core';
import {NotificationService} from "../../../../_services/notification.service";
import {waitForElm} from "../../../../_util/utils";
import { SpriteVersionDirective } from '../../../../_directives/spriteVersionDirective';
import { NgClass, NgForOf } from '@angular/common';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [
        SpriteVersionDirective,
        NgClass, NgForOf
    ]
})
export class NotificationComponent {
  list: any[] = [];
  private readonly notificationTimeouts = new Map<number, number[]>();

  constructor(private notifService: NotificationService) {
    this.notifService.showNotification.subscribe((config) => {
      config.id = Math.floor(Math.random() * 100);
      this.list.push(config);

      waitForElm(`#notification-${config.id}`).then((el) => {
        this.scheduleShowToggle(el as HTMLElement, config, 100);
        this.scheduleShowToggle(el as HTMLElement, config, 2100);
        this.scheduleRemove(config, 2350);
      })
    })
  }

  closeNotification(config: any) {
    this.clearNotificationTimeouts(config.id);
    this.removeFromList(config);
  }

  private scheduleShowToggle(el: HTMLElement, config: any, delayMs: number) {
    const timeoutId = window.setTimeout(() => {
      if (el) el.toggleAttribute('show')
    }, delayMs);

    this.addNotificationTimeout(config.id, timeoutId);
  }

  private scheduleRemove(config: any, delayMs: number) {
    const timeoutId = window.setTimeout(() => {
      this.clearNotificationTimeouts(config.id);
      this.removeFromList(config);
    }, delayMs);

    this.addNotificationTimeout(config.id, timeoutId);
  }

  private addNotificationTimeout(notificationId: number, timeoutId: number) {
    const existingTimeouts = this.notificationTimeouts.get(notificationId) ?? [];
    this.notificationTimeouts.set(notificationId, [...existingTimeouts, timeoutId]);
  }

  private clearNotificationTimeouts(notificationId: number) {
    const timeoutIds = this.notificationTimeouts.get(notificationId) ?? [];

    timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
    this.notificationTimeouts.delete(notificationId);
  }

  private removeFromList(config: any) {
    const notificationIndex = this.list.indexOf(config);

    if (notificationIndex === -1) {
      return;
    }

    this.list.splice(notificationIndex, 1);
  }
}
